
import axios from 'axios';
import Vue from 'vue';
import { Auth } from '@aws-amplify/auth';
import { Logger } from '@aws-amplify/core';

const logger = new Logger('FlightPathSignIn');
const NEW_PASSWORD = 'NEW_PASSWORD_REQUIRED';

export default Vue.extend({
  name: 'FlightpathSignIn',
  props: {
    baseUrl: {
      default: '',
      type: String
    },
    componentColor: {
      default: 'primary',
      type: String
    },
    componmentButtonColor: {
      default: 'primary',
      type: String
    }
  },
  data() {
    return {
      loader: null,
      passwordType1: true,
      passwordType2: true,
      loading: false,
      confirmLoading: false,
      formState: 'default',
      errorMessage: null,
      errorExists: false,
      user: null,
      form: {
        username: '',
        password: '',
        newPassword: '',
        newPasswordMatch: '',
        code: ''
      }
    };
  },
  methods: {
    async signIn(event: any) {
      event.preventDefault();
      this.errorExists = false;
      this.errorMessage = null;
      if (this.loading) return;
      const { username, password } = this.form;
      this.loading = true;
      try {
        this.user = await Auth.signIn(username, password);
        const newUser = this.user as any;
        if (newUser != null && newUser.challengeName === NEW_PASSWORD) {
          this.formState = 'confirm';
        } else {
          // Attach IoT policy on every successful login to ensure MQTT access
          await this.attachIotPolicy();
        }
      } catch (error) {
        logger.warn('error signing in', error);
        this.loading = false;
        this.loader = null;
        this.errorExists = true;
        const translationKey = 'auth.error.' + error.code;
        const translationExists = this.$te(translationKey);
        const message = translationExists ? this.$t('auth.error.' + error.code) : error.message;
        this.errorMessage = message;
      }
    },
    async attachIotPolicy() {
      try {
        const cognitoUserCreds = await Auth.currentUserCredentials();
        const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();

        const respo = await axios.post(`${this.baseUrl}/attach-iot-policy`, cognitoUserCreds.identityId, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        logger.info('IoT policy attached', respo);
      } catch (error) {
        // Log but don't fail login - policy might already be attached
        logger.warn('error attaching IoT policy', error);
      }
    },
    async confirmSignIn(event: any) {
      event.preventDefault();
      this.errorExists = false;
      this.errorMessage = null;
      if (this.confirmLoading) return;
      if (this.form.newPassword != this.form.newPasswordMatch) return;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { newPassword } = this.form;
      this.confirmLoading = true;
      try {
        await Auth.completeNewPassword(this.user, newPassword);
        await this.attachIotPolicy();
      } catch (error) {
        logger.warn('error confirm new password', error);
        this.confirmLoading = false;
        this.errorExists = true;
        const translationKey = 'auth.error.' + error.code;
        const translationExists = this.$te(translationKey);
        const message = translationExists ? this.$t('auth.error.' + error.code) : error.message;
        this.errorMessage = message;
      }
    },

    async forgotPassword() {
      try {
        this.formState = 'forgot';
      } catch (error) {
        this.errorExists = true;
        this.errorMessage = error.message;
      }
    },
    async confirmPassword() {
      this.errorExists = false;
      this.errorMessage = null;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { username, newPassword, code } = this.form;
      this.confirmLoading = true;
      try {
        await Auth.forgotPasswordSubmit(username, code, newPassword);
        this.formState = 'default';
      } catch (error) {
        logger.warn('error confirm new password', error);
        this.confirmLoading = false;
        this.loader = null;
        this.errorExists = true;
        const translationKey = 'auth.error.' + error.code;
        const translationExists = this.$te(translationKey);
        const message = translationExists ? this.$t('auth.error.' + error.code) : error.message;
        this.errorMessage = message;
      }
    }
  }
});
